// src/App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';
import Login from './components/Login';
import Map from './components/Map'; // Your map component

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true); // For loading state until authentication is checked

    useEffect(() => {
        // Recheck the logged-in user every time the app loads or refreshes
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setIsAuthenticated(!!user); // Set authentication status based on whether user is logged in
            setLoading(false); // Stop loading once we determine the auth status
        });

        return () => unsubscribe(); // Clean up the subscription
    }, []);

    if (loading) {
        // Optionally, show a loading spinner while checking auth status
        return <div>Loading...</div>;
    }

    return (
        <Router>
            <div>
                <Routes>
                    {isAuthenticated ? (
                        <>
                            {/* Use "/map" route for the Map component */}
                            <Route path="/" element={<Map />} />
                        </>
                    ) : (
                        <Route path="/" element={<Login onLoginSuccess={() => setIsAuthenticated(true)} />} />
                    )}

                    {/* Redirect unauthenticated users to login */}
                    {!isAuthenticated && <Route path="*" element={<Navigate to="/" />} />}
                </Routes>
            </div>
        </Router>
    );
}

export default App;
